export default __webpack_public_path__ + "static/media/hero-mobile-safari-PT.37004f0d.png";